export const resourceSharePath = (uuid: string): string =>
    `/share/resources/${encodeURIComponent(uuid)}`;

export const resourceDeepLink = (uuid: string): string =>
    `vocalcentric://resource?id=${encodeURIComponent(uuid)}`;

export const communityThreadSharePath = (uuid: string): string =>
    `/share/community/${encodeURIComponent(uuid)}`;

export const communityThreadDeepLink = (uuid: string): string =>
    `vocalcentric://community?post_uuid=${encodeURIComponent(uuid)}`;

export const teachingInvitationDeepLink = (token: string): string =>
    `vocalcentric://accept-teaching-invite?token=${encodeURIComponent(token)}`;

export const authenticatedResourceReturnPath = (value: string | null): string | null =>
    value && (
        /^\/share\/resources\/[^/?#]+(?:\?[^#]*)?$/.test(value) ||
        /^\/share\/community\/[^/?#]+(?:\?[^#]*)?$/.test(value) ||
        /^\/share\/accept-teaching-invitation(?:\?[^#]*)?$/.test(value) ||
        /^\/pub-share\/choirs\/[^/?#]+(?:\?[^#]*)?$/.test(value) ||
        /^\/claim-choir\/[^/?#]+(?:\?[^#]*)?$/.test(value)
    ) ? value : null;
